import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Bem from 'bemHelper';
import Image from 'components/image';
import Link from 'components/link';

import linksForum from 'src-sites/forum/links';

const bemClassesResidentials = new Bem('residentialComplexItem');

export default class SliderItem extends PureComponent {
  static propTypes = {
    className: PropTypes.string,
    data: PropTypes.shape({}),
    withLinkAndHeader: PropTypes.bool
  };

  renderImageLink(data) {
    return (
      <Link
        {...bemClassesResidentials('link', 'fill')}
        builder={linksForum.sectionTopic}
        builderProps={{
          ...data,
          noPage: true
        }}
      >
        <span />
      </Link>
    );
  }

  renderHeader(data) {
    return (
      <div {...bemClassesResidentials('topic')}>
        <span {...bemClassesResidentials('text')}>{data.name}</span>
      </div>
    );
  }

  renderLinkItem(href, title) {
    const { data = {} } = this.props;
    return (
      <div {...bemClassesResidentials('item')}>
        <span {...bemClassesResidentials('separate')} />
        <Link
          {...bemClassesResidentials('link')}
          href={href}
          onClick={() => window._paq.push(['trackEvent', data.name, title])}
          external
          blank
        >
          <span {...bemClassesResidentials('linkContent')}>
            <span {...bemClassesResidentials('text')}>{title}</span>
          </span>
        </Link>
      </div>
    );
  }

  render() {
    const { data = {}, withLinkAndHeader } = this.props;
    if (!data.id || !data.images || !data.images[0]) return null;
    return (
      <div {...bemClassesResidentials({ extra: this.props.className })}>
        <div {...bemClassesResidentials('imgContainer')}>
          <div {...bemClassesResidentials('img')}>
            <Image
              {...bemClassesResidentials('imgPic')}
              image={{ id: data.images[0], renderer: 'orig' }}
            />
            <div {...bemClassesResidentials('substrate')} />
            {withLinkAndHeader && this.renderHeader(data)}
            {withLinkAndHeader && this.renderImageLink(data)}
          </div>
        </div>
        <div {...bemClassesResidentials('links')}>
          {data.url_card && this.renderLinkItem(data.url_card, 'Карточка DOMIK')}
          {data.url_site && this.renderLinkItem(data.url_site, 'Сайт проекта')}
          {data.lun_card && this.renderLinkItem(data.lun_card, 'Карточка ЛУН')}
        </div>
      </div>
    );
  }
}
